export const EMPLOYEE_DETAILS_TABS = {
  personalInfo: 'personalInfo',
  workingConditions: 'workingConditions',
  wagesAndSalary: 'wagesAndSalary',
  paymentAndInsurance: 'paymentAndInsurance',
  employeeDocuments: 'employeeDocuments',
  processes: 'processes',
  educationsAndSkills: 'educationsAndSkills',
};
